
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ef32u", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $iLgzu = parcelRequire("iLgzu");


var $5rZJf = parcelRequire("5rZJf");

const $1546310cc6a3e3ac$export$b04f2418ece85f67 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== currentSpaceKey) {
        t0 = {
            variables: {
                promotedSpaceKey: currentSpaceKey,
                promotedSpacesLimit: 1,
                otherSpacesLimit: 1
            }
        };
        $[0] = currentSpaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const { data: promotedSpaceData, error: promotedSpaceError } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t0);
    const spaceKey = promotedSpaceData?.experimentalPromotedSpaces?.nodes?.[0]?.id || "";
    let t1;
    if ($[2] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[2] = spaceKey;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = !spaceKey;
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    const { error: operationsError } = (0, $j1Ss3.useQuery)((0, $5rZJf.SpaceOperationsQuery), t3);
    let t4;
    let t5;
    if ($[7] !== operationsError || $[8] !== promotedSpaceError) {
        t4 = ()=>{
            (0, $7Sm4c.markErrorAsHandled)(promotedSpaceError);
            (0, $7Sm4c.markErrorAsHandled)(operationsError);
        };
        t5 = [
            promotedSpaceError,
            operationsError
        ];
        $[7] = operationsError;
        $[8] = promotedSpaceError;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $42omo.useEffect)(t4, t5);
    return null;
} : ()=>{
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: promotedSpaceData, error: promotedSpaceError } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        variables: {
            promotedSpaceKey: currentSpaceKey,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    });
    const spaceKey = promotedSpaceData?.experimentalPromotedSpaces?.nodes?.[0]?.id || '';
    const { error: operationsError } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $5rZJf.SpaceOperationsQuery), {
        variables: {
            spaceKey: spaceKey
        },
        skip: !spaceKey
    });
    (0, $42omo.useEffect)(()=>{
        // error will be reported if the user actually triggers a create via the handler
        (0, $7Sm4c.markErrorAsHandled)(promotedSpaceError);
        (0, $7Sm4c.markErrorAsHandled)(operationsError);
    }, [
        promotedSpaceError,
        operationsError
    ]);
    return null;
};
module.exports["CreateContentDataPreloader"] = $1546310cc6a3e3ac$export$b04f2418ece85f67;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("5rZJf", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $eSUdr.default)`query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id operations{operation targetType}}}`;
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});


//# sourceMappingURL=CreateContentDataPreloader.d2f8e6b9.js.map
